/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { TextField, Box, InputAdornment } from '@mui/material';
import { SxProps } from '@mui/system';
import { Icons } from '../../../../../../Shared/Constants/Icons';

interface IAnnualScheduleProps {
  control: Control<any>;
  textFieldStyle?: SxProps;
  label?: React.ReactNode;
}

const AnnualSchedule: React.FC<IAnnualScheduleProps> = ({ control, textFieldStyle, label }) => {
  return (
    <>
      {label}
      <Box sx={{ display: 'flex', alignItems: 'center', padding: '0.75rem 0' }}>
        <Controller
          control={control}
          name="scheduleDays"
          // eslint-disable-next-line sonarjs/cognitive-complexity
          render={({ field: { onChange, value } }) => {
            // Convert stored M4-3 to display format 04-03
            const displayValue = (() => {
              if (!value) return '';
              const rawValue = Array.isArray(value) ? value[0] : value;
              if (typeof rawValue === 'string' && rawValue.startsWith('M')) {
                const parts = rawValue.substring(1).split('-');
                if (parts.length === 2) {
                  return `${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                }
              }
              return rawValue;
            })();

            return (
              <TextField
                fullWidth
                sx={textFieldStyle}
                value={displayValue}
                onChange={(e) => {
                  const newValue = e.target.value;
                  // Store as M4-3 format when complete, or raw input if not
                  if (newValue.length === 5 && newValue.includes('-')) {
                    const [month, day] = newValue.split('-');
                    onChange(`M${parseInt(month)}-${parseInt(day)}`);
                  } else {
                    onChange(newValue);
                  }
                }}
                onBlur={(e) => {
                  if (e.target.value.includes('-')) {
                    const [month, day] = e.target.value.split('-');
                    // const formatted = `${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                    onChange(`M${parseInt(month || '0')}-${parseInt(day || '0')}`);
                  }
                }}
                placeholder="MM-DD"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {displayValue && (
                        <img src={Icons.CancelIcon} onClick={() => onChange('')} style={{ cursor: 'pointer' }} />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            );
          }}
        />
      </Box>
    </>
  );
};

export default AnnualSchedule;
